import { Table, TableBody, TableContainer, TableHead, TableRow, Typography, Box, Avatar } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@emotion/react'
import TableCell from '@mui/material/TableCell'
import TableHeadCell from 'components/TableHeadCell'
import 'utils/global.scss'

export default function Index({ attendanceReports, absenceRate }) {
  const { t } = useTranslation()
  const theme = useTheme()

  const headCellSx = { borderBottom: '1px solid orange' }
  const labelColSx = { minWidth: 130 }
  const numColSx = { width: 64 }

  return (
    <Box sx={{ my: 2, mx: { xs: 1, sm: 2, md: 3 }, width: '100%', maxWidth: 800 }}>
      <Box>
        <Typography variant="h6" gutterBottom>
          {t('Daily Attendance Summary')}{' '}
        </Typography>
        <TableContainer sx={{ overflowX: 'auto' }}>
          <Table sx={{ minWidth: 340 }}>
            <TableHead>
              <TableRow>
                <TableHeadCell className="font-weight-500 font-size-14" sx={{ ...headCellSx, ...labelColSx }}>
                  {t('Status')}
                </TableHeadCell>
                <TableHeadCell className="font-weight-500 font-size-14" sx={{ ...headCellSx, ...numColSx }}>
                  {t('Present')}
                </TableHeadCell>
                <TableHeadCell className="font-weight-500 font-size-14" sx={{ ...headCellSx, ...numColSx }}>
                  {t('Tardy')}
                </TableHeadCell>
                <TableHeadCell className="font-weight-500 font-size-14" sx={{ ...headCellSx, ...numColSx }}>
                  {t('Absent')}
                </TableHeadCell>
              </TableRow>
            </TableHead>
            <TableBody sx={{ backgroundColor: theme.palette.action.hover }}>
              <TableRow>
                <TableCell sx={labelColSx}>
                  {t('Absence Rate')}: {Math.round(absenceRate)} %
                </TableCell>
                <TableCell sx={numColSx}>
                  <Avatar sx={{ bgcolor: 'green' }}>{attendanceReports?.daily?.present ?? '-'}</Avatar>
                </TableCell>
                <TableCell sx={numColSx}>
                  <Avatar sx={{ bgcolor: 'orange' }}>{attendanceReports?.daily?.tardy ?? '-'}</Avatar>
                </TableCell>
                <TableCell sx={numColSx}>
                  <Avatar sx={{ bgcolor: 'red' }}>{attendanceReports?.daily?.absent ?? '-'}</Avatar>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Box sx={{ mt: '30px' }}>
        <Typography variant="h6" gutterBottom>
          {t('Course Attendance Summary')}
        </Typography>
        <TableContainer sx={{ overflowX: 'auto' }}>
          <Table sx={{ minWidth: 340 }}>
            <TableHead>
              <TableRow>
                <TableHeadCell className="font-weight-500 font-size-14" sx={{ ...headCellSx, ...labelColSx }}>
                  {t('Course Name')}
                </TableHeadCell>
                <TableHeadCell className="font-weight-500 font-size-14" sx={{ ...headCellSx, ...numColSx }}>
                  {t('Present')}
                </TableHeadCell>
                <TableHeadCell className="font-weight-500 font-size-14" sx={{ ...headCellSx, ...numColSx }}>
                  {t('Tardy')}
                </TableHeadCell>
                <TableHeadCell className="font-weight-500 font-size-14" sx={{ ...headCellSx, ...numColSx }}>
                  {t('Absent')}
                </TableHeadCell>
              </TableRow>
            </TableHead>
            {attendanceReports?.courseSessions?.map((item, index) => (
              <TableBody key={item.id} sx={index % 2 === 0 ? { backgroundColor: theme.palette.action.hover } : null}>
                <TableRow>
                  <TableCell sx={labelColSx}>
                    {item.course.name}
                  </TableCell>
                  <TableCell sx={numColSx}>
                    {item.present ?? '-'}
                  </TableCell>
                  <TableCell sx={numColSx}>
                    {item.tardy ?? '-'}
                  </TableCell>
                  <TableCell sx={numColSx}>
                    {item.absent ?? '-'}
                  </TableCell>
                </TableRow>
              </TableBody>
            ))}
          </Table>
        </TableContainer>
      </Box>
    </Box>
  )
}
